<template>
  <div class="select-item" :class="{'larges':index==0}">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'filterFence',
  props: {
    index: Number
  },
  data(){
    return{
    }
  }
}
</script>
<style scoped >


</style>